<template>
  <div
    class="login-content"
    v-loading="loading"
    element-loading-text="正在登录..."
    element-loading-customClass="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="banner-back">
      <div class="login-form">
        <div class="title">管理员账号登录</div>
        <el-form
          :model="reqData"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
          class="demo-ruleForm"
        >
          <el-form-item prop="account" class="usr-item">
            <el-input
              type="text"
              v-model.trim="reqData.account"
              maxlength="20"
              autocomplete="off"
              placeholder="请输入账号"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" class="pwd-item">
            <el-input
              type="password"
              v-model.trim="reqData.password"
              autocomplete="off"
              placeholder="请输入管理员密码"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <div class="operate-btn">
            <p class="reback-pwd" @click="isShowDialog=!isShowDialog">忘记密码</p>
            <el-button type="primary" @click="submitForm('ruleForm')" class="submit-btn">登录</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <footer>
      <img src="../../assets/images/vitologo.png" alt />
      <span>版权所有 Copyright &copy;2018-2019 <a href="http://www.beian.miit.gov.cn/" target="_blank">蜀ICP备18014140号</a> VITO. All rights reserved.</span>
    </footer>
      <rebackDialog :isShowDialog="isShowDialog"></rebackDialog>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
import api from "@/api/index.js";
import { dealData } from "@/utils/auth.js";
import rebackDialog from "@/components/rebackDialog.vue";
export default {
  components: { rebackDialog },
  data() {
    return {
      loading: false,
      isShowDialog: false,
      reqData: {
        account: "",
        password: ""
      },
      userInfo:{},
      menuList: [],
      rules: {
        //验证规则
        account: [
          { required: true, message: "请输入账号", trigger: "blur" }
          // {pattern: /^1[34578]\d{9}$/, message: '请输入正确的账号',trigger: 'blur'}
        ],
        password: [
          { required: true, message: "请输入管理员密码", trigger: "blur" }
        ]
      },
    };
  },

  methods: {
    submitForm(formName) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      let data = Object.assign({}, this.reqData, {
        password: Base64.encode(this.reqData.password)
      });
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;
        let res = await this.$http.post(api.login, this.$qs.stringify(data));
        if (res && res.isSucceed) {
          // 存入token
          let data=res.newPrimaryKeys
          let token =data.token_type +" " +data.access_token;
          this.$store.commit("SET_TOKEN", token);
          this.userInfo={...data}
          // 获取用户信息
          this.getUserInfo();
        }
      });
    },
    // 获取用户信息
    async getUserInfo() {
      let res = await this.$http.post(api.getUserInfo);
      if (res && res.isSucceed) {
          this.dealUserData(res);
      }
    },

    // 多社区中选择默认选择第一个社区
    dealUserData(data) {
      this.userInfo= {...this.userInfo,...data.data};
      this.userInfo.userName = data.data.nickName;
      this.userInfo.loginTime = new Date().getTime();
      this.userInfo.communties = data.rows || [];
      let communities = data.rows;
      if (!communities || communities.length <= 0) {
        this.$message.error("该账号未绑定任何社区");
        return;
      }
      //   for (let item of communities) {
      //     if (item.selected === 1) {
      //         userInfo.communityId=item.projectId
      //         Object.assign(userInfo,item)
      //     }
      //   }
      if (!this.userInfo.communityId) {
        this.userInfo.communityId = communities[0].projectId;
      }
      Object.assign(this.userInfo, communities[0]);
      this.$store.commit("SET_USER", this.userInfo);
      this.getMenu();
    },

    async getMenu() {
      let data = {
        userId: this.$store.state.userInfo.userId,
        communityId: this.$store.state.userInfo.communityId,
        viewType: 1
      };
      let res = await this.$http.get(api.getMenu, { params: data });
      if (res && res.isSucceed) {
        dealData(res.rows);
        this.$store.commit("SET_ROUTERS", res.rows);
        this.$router.push("/");
      }
    },
  }
};
</script>
<style lang='less' scoped>
@import url("./index.less");
</style>
<style lang='less'>
@import url("./ele-index.less");

.el-loading-spinner i {
  color: #fff;
  font-size: 20px;
}

.el-loading-spinner .el-loading-text {
  color: #fff;
  font-size: 16px;
}
</style>
